
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compound-interest",
      function () {
        return require("private-next-pages/compound-interest.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compound-interest"])
      });
    }
  